import {cdnImage} from '@/util/cdnImage';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
const check = cdnImage('Home-page/check.svg');
import dynamic from 'next/dynamic';
const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'));
import parse from 'html-react-parser';
import MUIContainer from '@/components/MUI-Components/MUI-Container';

const OurMakeChoice = (props: any) => {
    const {heading, subheading, body, contentData} = props;
    return (
        <Box className="make-our-white-label-wrapper bg-blue-background">
            <MUIContainer>
                <Grid container spacing={1}>
                    <Grid item md={6} xs={12}>
                        {heading && <Typography className="makes-our-heading font-headers">{heading}</Typography>}
                        {subheading && <Typography className="makes-our-subheading font-headers">{subheading} </Typography>}
                        {body?.map((item: any, index: number) => (
                            <Typography className="makes-our-body" key={index + 1}>
                                {parse(item)}
                            </Typography>
                        ))}
                    </Grid>
                    <Grid item md={6} xs={12} className="trading-item-main-wrapper">
                        {contentData?.map((item: any, index: number) => (
                            <Box className="done-icon-wrapper" key={index + 1}>
                                <Box mt={0.5}>
                                    <DisplayImage src={check} alt="check Icon" width={22} priority={false} />
                                </Box>
                                <Box>
                                    {item?.heading && <Typography className="done-heading font-headers">{parse(item.heading)}</Typography>}
                                    {item?.subheading && <Typography className="done-subheading ">{parse(item.subheading)}</Typography>}
                                </Box>
                            </Box>
                        ))}
                    </Grid>
                </Grid>
            </MUIContainer>
        </Box>
    );
};

export default memo(OurMakeChoice);
